import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarHeader,
  SidebarContent,
  SidebarFooter
} from "react-pro-sidebar";
import ClickOutside from './ClickOutside'
import { getPendingRequests } from '../../flux/actions/userActions'
import { PRIVILEGE } from '../../types/privileges'
import { constants } from '../../types/constants'
import ClientAdd from '../client/ClientAdd';
import ProspectAdd from '../prospects/ProspectAdd';
import VisitorAdd from '../visitors/VisitorAdd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserLock, faMoneyCheckAlt, faFileSignature, faUsers, faTools, faPlus, faPen, faBookmark, faHouseUser, faShoppingBasket, faCheckDouble, faLock, faPercent, faHandHoldingUsd, faUserPlus, faUserEdit, faUnlock, faDesktop, faSignInAlt, faMapMarkedAlt, faStore, faBuilding, faClipboardCheck, faUserShield, faTh, faUserTag, faWallet, faExchangeAlt, faSearchDollar, faUserMinus, faStoreAltSlash, faUserSlash, faCommentsDollar, faCalculator, faFileInvoiceDollar, faBullseye, faChartArea, faListAlt, faChartBar, faBars, faBoxes, faEdit, faUserClock, faUserCheck, faSignature, faTimesCircle, faList, faHourglassHalf, faCalendarTimes, faStream, faFileExcel, faTasks, faBell } from '@fortawesome/free-solid-svg-icons'

import './styles.css';

const ProSideBar = ({location, history, auth = {}}) => {
  const [collapsed, setCollapsed] = useState(true);
  const [clientAddModal, setClientAddModal] = React.useState(false);
  const [prospectAddModal, setProspectAddModal] = React.useState(false);
  const [visitorAddModal, setVisitorAddModal] = React.useState(false);
  const [pending, setPending] = React.useState(undefined);
  
  const handleClientAddToggle = () => setClientAddModal(!clientAddModal);

  useEffect(() => {
    setPending(undefined)
    getPendingRequests()
    .then(e => setPending(e))
  }, [])

  const commercialLinks = {
    title: "Commercial",
    icon: faShoppingBasket,
    specialities: [constants.ROLE_COMMERCIAL, constants.ROLE_RESPONSABLE, constants.ROLE_ADMIN, constants.ROLE_PROMOTEUR, constants.ROLE_INTERMEDIAIRE, constants.ROLE_DG, constants.ROLE_DC, constants.ROLE_DAF],
    links: [
      {title: "Nouvelle Vente", icon: faFileSignature, subLinks: [
        {path: "/vente", title: "Vente Normale", icon: faUserLock, privilege: PRIVILEGE.VENTE_NORMALE},
        {path: "/association", title: "Vente Association", icon: faUsers, privilege: PRIVILEGE.VENTE_ASSOCIATION}
      ]},
      {title: "Nouvel Encaissement", icon: faMoneyCheckAlt, subLinks: [
        {path: "/nouvel_encaissement", title: "Nouvel Encaissement", icon: faMoneyCheckAlt, privilege: PRIVILEGE.ADD_ENCAISSEMENT},
        {path: "/remplacement_encaissement", title: "Remplacer un Chèque", icon: faCommentsDollar, privilege: PRIVILEGE.ADD_ENCAISSEMENT},
      ]},
      {path: "/consultation", title: "Consultation", icon: faBookmark, privilege: PRIVILEGE.CONSULTATION},
      {title: "Rapports", icon: faHouseUser, subLinks: [
        {path: "/mes_ventes", title: "Mes Ventes", icon: faHandHoldingUsd, privilege: PRIVILEGE.MY_VENTES},
        {path: "/mes_encaissements", title: "Mes Encaissements", icon: faWallet, privilege: PRIVILEGE.MY_VENTES},
        {path: "/liste_biens", title: "Liste des Biens", icon: faBoxes, privilege: PRIVILEGE.LIST_BIEN},
        {path: "/liste_ventes", title: "Liste des Biens Vendus", icon: faHouseUser, privilege: PRIVILEGE.LIST_VENTES},
        {path: "/modification_charges_biens", title: "Chargés des Biens", icon: faUserShield, privilege: PRIVILEGE.EDIT_CHARGE},
        {path: "/resume_projets", title: "Récap par Projet", icon: faTh, privilege: PRIVILEGE.SUMMARY_PROJECT},
        {path: "/resume_charges", title: "Récap par Chargé", icon: faUsers, privilege: PRIVILEGE.SUMMARY_PROJECT},
        {path: "/ventes_par_charge", title: "Recouvrement par Chargé", icon: faUserTag, privilege: PRIVILEGE.MY_VENTES},
        {path: "/total_pourcentages_parts", title: "Pourcentages des Parts", icon: faBars, privilege: PRIVILEGE.CONSULTATION/*POURCENTAGES_PARTS*/},
        {path: "/ventes_minutes", title: "Suivi des Minutes", icon: faSignature, privilege: PRIVILEGE.EXPEDITION_MINUTE/*POURCENTAGES_PARTS*/},
        // {path: "/ventes_par_charge_2", title: "Ventes par Chargé 2 (Temporaire)", icon: faHandHoldingUsd, privilege: PRIVILEGE.VENTES_BY_CHARGE},
        // {path: "/ventes_par_charge", title: auth?.user?.underlings?.filter(e => e.id !== auth?.user?.id).length ? "Ventes par Commercial" : "Mes Ventes", icon: faHandHoldingUsd, privilege: PRIVILEGE.MY_VENTES}
      ]},
      {title: "Clients", icon: faUsers, subLinks: [
        {title: "Nouveau Client", onClick: () => setClientAddModal(true), icon: faUserPlus, privilege: PRIVILEGE.ADD_CLIENT},
        {path: "/clients", title: "Liste des Clients", icon: faUsers, privilege: PRIVILEGE.LIST_CLIENTS},
        // {title: "Nouveau Prospect", onClick: () => setProspectAddModal(true), icon: faUserPlus, privilege: PRIVILEGE.ADD_CLIENT},
        {path: "/prospects", title: "Prospects", icon: faUserCheck, privilege: PRIVILEGE.ADD_CLIENT},
        // {title: "Nouveau Visiteur", onClick: () => setVisitorAddModal(true), icon: faUserPlus, privilege: PRIVILEGE.ADD_VISITORS},
        {path: "/visiteurs", title: "Visiteurs", icon: faUserClock, privilege: PRIVILEGE.ADD_VISITORS},
      ]},
      {path: "/plan", onClick: ev => {
        if (ev.ctrlKey)
          window.open("/plan")
        else
          window.location.href = "/plan"
      }, title: "Plan de Masse", icon: faMapMarkedAlt, privilege: PRIVILEGE.PLAN_MASSE},
    ]
  };

  const suiviReglementLinks = {
    title: "Suivi des Règlements",
    icon: /*faCheckDouble*/faSearchDollar,
    speciality: constants.ROLE_COMPTABLE,
    links: [
      // {path: "/construction", title: "Consultation", icon: faTools, privilege: PRIVILEGE.CONSULTATION_COMPTA},
      {title: "Portefeuille Bureau Vente", icon: faStore, subLinks: [
        {path: "/portefeuille_bureau_vente", title: "Réceptionner", icon: faStore, privilege: PRIVILEGE.PORTEFEUILLE_BUREAU_VENTE},
        {path: "/encaissements_receptionnes", title: "Liste réceptionnés", icon: faList, iconWhenAlone: faStore, privilege: PRIVILEGE.LIST_ENCAISSEMENTS},
      ]},
      {path: "/envoi_a_la_comptabilite", title: "Remettre à la Compta.", icon: faHandHoldingUsd, privilege: PRIVILEGE.SEND_ENC_TO_COMPTA},
      {title: "Portefeuille Siège", icon: faBuilding, subLinks: [
        {path: "/portefeuille_siege", title: "Verser", icon: faBuilding, privilege: PRIVILEGE.PORTEFEUILLE_SIEGE},
        {path: "/encaissements_verses", title: "Liste versés", icon: faList, iconWhenAlone: faBuilding, privilege: PRIVILEGE.LIST_ENCAISSEMENTS},
      ]},
      // {path: "/portefeuille_comptabilite", title: "Portefeuille Comptabilité", icon: faTools, privilege: PRIVILEGE.PORTEFEUILLE_COMPTA},
      // {path: "/construction", title: "À Verser", icon: faTools, privilege: PRIVILEGE.A_VERSER},
      // {path: "/construction", title: "Spécial", icon: faTools, privilege: PRIVILEGE.SPECIAL_COMPTA},
      {title: "Rapprochement Relevé de compte", icon: faStream, subLinks: [
        {path: "/rapprochement_encaissements", title: "Extraction Excel", icon: faFileExcel, privilege: PRIVILEGE.RAPPROCHEMENT_ENC},
        {path: "/rapprochement_manuel", title: "Rapprochement Manuel", icon: faTasks, privilege: PRIVILEGE.RAPPROCHEMENT_ENC},
      ]},
      {path: "/encaisses_impayes", title: "Encaissé/Impayé", icon: faClipboardCheck, privilege: PRIVILEGE.ENCAISSE_IMPAYE},
      {path: "/remplacement_cheques", title: "Remplacement des Chèques", icon: faCommentsDollar, privilege: PRIVILEGE.REPLACE_ENCAISSEMENT},
      // {title: "Remplacement des Chèques", icon: faCommentsDollar, subLinks: [
      //   {path: "/remplacement_cheques", title: "Remplacer", icon: faCommentsDollar, privilege: PRIVILEGE.REPLACE_ENCAISSEMENT},
      //   {path: "/demandes_remplacements_cheques", title: "Demandes de Remplacements", icon: faTasks, privilege: PRIVILEGE.REPLACE_ENCAISSEMENT},
      // ]},
      {path: "/encaissements_notaire", title: "Encaissements (Notaire)", icon: faSignature, privilege: PRIVILEGE.LIST_ENCAISSEMENTS_NOTAIRE},
      {path: "/encaissements", title: "Tous les Encaissements", icon: faMoneyCheckAlt, privilege: PRIVILEGE.LIST_ENCAISSEMENTS},
      // {path: "/construction", title: "Liste Encaissés", icon: faTools, privilege: PRIVILEGE.LIST_ENCAISSES},
      // {path: "/construction", title: "Liste Impayés", icon: faTools, privilege: PRIVILEGE.LIST_IMPAYES},
      // {path: "/construction", title: "État Portefeuille", icon: faTools, privilege: PRIVILEGE.ETAT_PORTEFEUILLE},
      // {path: "/construction", title: "Liste en Instance", icon: faTools, privilege: PRIVILEGE.LISTE_EN_INSTANCE},
      // {path: "/testplan", title: "Test", icon: faTools, privilege: PRIVILEGE.PLAN_MASSE},
    ]
  };

  const securiteLinks = {
    title: "Sécurité",
    icon: faLock,
    specialities: [],
    links: [
      {path: "/utilisateurs", title: "Utilisateurs", icon: faUsers, privilege: PRIVILEGE.USERS},
      // {path: "/construction", title: "Banques Virements", icon: faTools, privilege: PRIVILEGE.BANQUES_VIREMENT},
      {path: "/parc_informatique", title: "Parc Informatique", icon: faDesktop, privilege: PRIVILEGE.PARC_INFORMATIQUE},
      {path: "/journal_connexions", title: "Journal des Connexions", icon: faSignInAlt, privilege: PRIVILEGE.PARC_INFORMATIQUE},
      {path: "/notifications", title: "Gestion des Notifications", icon: faBell, privilege: PRIVILEGE.MANAGE_NOTIFICATIONS},
    ]
  };

  const moderationLinks = {
    title: "Modération",
    icon: faUserLock,
    specialities: [],
    links: [
      {path: "/consultation", title: "Changement Prix", icon: faCommentsDollar, privilege: PRIVILEGE.CHANGEMENT_PRIX},
      {path: "/construction", title: "Déblocage/Blocage", icon: faTools, privilege: PRIVILEGE.DEBLOCAGE_BLOCAGE},
      {title: "Demandes validation encaissements", icon: faMoneyCheckAlt, subLinks: [
        {path: "/encaissements_a_valider", title: "Non validés", icon: faTimesCircle, privilege: PRIVILEGE.VALIDATION_ENC, pendingCode: "encNotValid"},
        {path: "/encaissements_a_ne_pas_verser", title: "À ne pas verser", icon: faCalendarTimes, privilege: PRIVILEGE.VALIDATION_ENC, pendingCode: "encAnpv"},
        {path: "/encaissements_a_prolonger", title: "Prolongation d'encaissement", icon: faHourglassHalf, privilege: PRIVILEGE.VALIDATION_ENC, pendingCode: "encDelay"},
        {path: "/demandes_remplacements_cheques", title: "Remplacements de chèques", icon: faCommentsDollar, privilege: PRIVILEGE.REPLACE_ENCAISSEMENT, pendingCode: "encSortis"},
      ]},
      {path: "/demandes_remise", title: "Demandes de Remise", icon: faPercent, privilege: PRIVILEGE.REMISE_ADMIN, pendingCode: "drs"},
      // {path: "/demandes_ouverture_association", title: "Association", icon: faUnlock, privilege: PRIVILEGE.ASSOCIATION_ADMIN},
      {path: "/demandes_ouverture_association", title: "Demandes d'associations", icon: faUnlock, privilege: PRIVILEGE.ASSOCIATION_ADMIN, pendingCode: "doas"},
      // {title: "Demandes Associations", icon: faUnlock, subLinks: [
      //   {path: "/demandes_ouverture_association", title: "Demandes d'ouverture", icon: faUnlock, privilege: PRIVILEGE.ASSOCIATION_ADMIN, pendingCode: "doas"},
      //   {path: "/demandes_repartition", title: "Demandes de répartition", icon: faUnlock, privilege: PRIVILEGE.APPROVE_DIVISION},
      // ]},
      {title: "Transferts et Désistements", icon: faExchangeAlt, subLinks: [
        {path: "/desistement", title: "Désistements", icon: faUserSlash, atLeastOnePrivilege: [PRIVILEGE.DESISTEMENT, PRIVILEGE.FICHE_DESISTEMENT]},
        {path: "/transfert", title: "Transferts", icon: faExchangeAlt, atLeastOnePrivilege: [PRIVILEGE.TRANSFERT, PRIVILEGE.FICHE_DESISTEMENT]},
        {path: "/changement_bien", title: "Changement de Bien", icon: faStoreAltSlash, atLeastOnePrivilege: [PRIVILEGE.CHANGEMENT_BIEN, PRIVILEGE.FICHE_DESISTEMENT]},
      ]},
      {path: "/dt", title: "Transferts et Désistements", icon: faExchangeAlt, privilege: PRIVILEGE.WEBMASTER},
      {title: "Commissions", icon: faFileInvoiceDollar, subLinks: [
        {path: "/commissions", title: "Gestion des Commissions", icon: faCalculator, privilege: PRIVILEGE.COMMISSIONS_PAGE},
        {path: "/bulletins_commissions", title: "Bulletins des Commissions", icon: faListAlt, privilege: PRIVILEGE.COMMISSIONS_PAGE},
        {path: "/paiement_commissions", title: "Paiement des Commissions", icon: faFileInvoiceDollar, privilege: PRIVILEGE.VALIDATE_COMMISSIONS},
      ]},
      {title: "Objectifs", icon: faBullseye, subLinks: [
        {path: "/budget", title: "Budget - Vue globale", icon: faChartArea, atLeastOnePrivilege: [PRIVILEGE.LIST_GOALS, PRIVILEGE.LIST_BUDGETS]},
        {path: "/objectif_charges_biens", title: "Budget - Commerciaux", icon: faUsers, privilege: PRIVILEGE.LIST_GOALS},
        {path: "/objectif_par_charge", title: "Budget - Commercial", icon: faBullseye, privilege: PRIVILEGE.OWN_GOAL},
        {path: "/objectifs", title: "Modification des Budgets", icon: faEdit, atLeastOnePrivilege: [PRIVILEGE.EDIT_GOALS, PRIVILEGE.EDIT_BUDGETS]},
      ]},
    ]
  };

  const allLinks = [commercialLinks, suiviReglementLinks, moderationLinks, securiteLinks]

  const isAtPath = pathname => {
    if(location?.pathname?.split("/").length >= 2)
      return '/' + location?.pathname?.split("/")[1] === pathname
    return false
  }

  const goToPath = (event, pathname) => {
    if (event.ctrlKey)
      window.open(pathname)
    else
      history.push(pathname);
    setCollapsed(true)
  }

  // const getLinks = (section, authPrivileges) => {
  //   return section?.links?.map((e, key) => (!e.privilege && !e.atLeastOnePrivilege && (!e.subLinks || e.subLinks.filter(t => (!t.privilege && !t.atLeastOnePrivilege) || (t.privilege && authPrivileges.includes(t.privilege)) || (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))).length > 0)) || (e.privilege && authPrivileges.includes(e.privilege)) || (e.atLeastOnePrivilege && e.atLeastOnePrivilege.some(n => authPrivileges.includes(n))) ? e.subLinks ? (e.subLinks.filter(t => (!t.privilege && !t.atLeastOnePrivilege) || (t.privilege && authPrivileges.includes(t.privilege)) || (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))).length > 1 ? <SubMenu title={e.title} icon={<FontAwesomeIcon icon={e.icon} />} className={!!e.subLinks.find(t => isAtPath(t.path)) ? "myProSideBarActiveSubMenu" : ""} key={key}>
  //     {e.subLinks.filter(t => (!t.privilege && !t.atLeastOnePrivilege) || (t.privilege && authPrivileges.includes(t.privilege)) || (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))).map((t, tKey) => <MenuItem onClick={t.onClick ? t.onClick : ev => goToPath(ev, t.path)} active={isAtPath(t.path)} icon={<FontAwesomeIcon icon={t.icon} />} title={t.title} key={tKey}>{t.title}</MenuItem>)}
  //   </SubMenu> : e.subLinks.filter(t => (!t.privilege && !t.atLeastOnePrivilege) || (t.privilege && authPrivileges.includes(t.privilege)) || (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))).length === 1 ? <MenuItem icon={<FontAwesomeIcon icon={e.subLinks.find(t => (!t.privilege && !t.atLeastOnePrivilege) || (t.privilege && authPrivileges.includes(t.privilege)) || (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))).iconWhenAlone || e.subLinks.find(t => (!t.privilege && !t.atLeastOnePrivilege) || (t.privilege && authPrivileges.includes(t.privilege)) || (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))).icon} />} onClick={e.subLinks.find(t => (!t.privilege && !t.atLeastOnePrivilege) || (t.privilege && authPrivileges.includes(t.privilege)) || (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))).onClick ? e.subLinks.find(t => (!t.privilege && !t.atLeastOnePrivilege) || (t.privilege && authPrivileges.includes(t.privilege)) || (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))).onClick : ev => goToPath(ev, e.subLinks.find(t => (!t.privilege && !t.atLeastOnePrivilege) || (t.privilege && authPrivileges.includes(t.privilege)) || (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))).path)} active={isAtPath(e.subLinks.find(t => (!t.privilege && !t.atLeastOnePrivilege) || (t.privilege && authPrivileges.includes(t.privilege)) || (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))).path)} title={e.subLinks.find(t => (!t.privilege && !t.atLeastOnePrivilege) || (t.privilege && authPrivileges.includes(t.privilege)) || (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))).title} key={key}>{e.subLinks.find(t => (!t.privilege && !t.atLeastOnePrivilege) || (t.privilege && authPrivileges.includes(t.privilege)) || (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))).title}</MenuItem> : null) : <MenuItem icon={<FontAwesomeIcon icon={e.icon} />} onClick={e.onClick ? e.onClick : ev => goToPath(ev, e.path)} active={isAtPath(e.path)} title={e.title} key={key}>{e.title}</MenuItem> : null)
  // }

  const getLinks_ = (section, authPrivileges) => {
    return section?.links?.map((e, key) => {
      return (!e.privilege && !e.atLeastOnePrivilege &&
          (!e.subLinks ||
            e.subLinks.filter(t =>
              (!t.privilege && !t.atLeastOnePrivilege) ||
              (t.privilege && authPrivileges.includes(t.privilege)) ||
              (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))
            ).length > 0
          )
        ) ||
        (e.privilege && authPrivileges.includes(e.privilege)) ||
        (e.atLeastOnePrivilege && e.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))
          ? e.subLinks
            ? (
              e.subLinks.filter(t =>
                (!t.privilege && !t.atLeastOnePrivilege) ||
                (t.privilege && authPrivileges.includes(t.privilege)) ||
                (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))
              ).length > 1
                ? <SubMenu
                    title={e.title}
                    icon={<FontAwesomeIcon icon={e.icon} />}
                    className={!!e.subLinks.find(t => isAtPath(t.path)) ? "myProSideBarActiveSubMenu" : ""}
                    key={key}
                  >
                    {e.subLinks.filter(t =>
                      (!t.privilege && !t.atLeastOnePrivilege) ||
                      (t.privilege && authPrivileges.includes(t.privilege)) ||
                      (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))
                    ).map((t, tKey) =>
                      <MenuItem
                        onClick={t.onClick ? t.onClick : ev => goToPath(ev, t.path)}
                        active={isAtPath(t.path)}
                        icon={<FontAwesomeIcon icon={t.icon} />}
                        title={t.title}
                        key={tKey}
                        suffix={!!(t.pendingCode && pending?.[t.pendingCode]) && <span className="sideBarBadge">{pending?.[t.pendingCode]}</span>}
                      >
                        {t.title}
                      </MenuItem>
                    )}
                  </SubMenu>
                : e.subLinks.filter(t =>
                  (!t.privilege && !t.atLeastOnePrivilege) ||
                  (t.privilege && authPrivileges.includes(t.privilege)) ||
                  (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))
                ).length === 1
                  ? <MenuItem
                      icon={
                        <FontAwesomeIcon
                          icon={
                            e.subLinks.find(t =>
                              (!t.privilege && !t.atLeastOnePrivilege) ||
                              (t.privilege && authPrivileges.includes(t.privilege)) ||
                              (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))
                            ).iconWhenAlone ||
                            e.subLinks.find(t =>
                              (!t.privilege && !t.atLeastOnePrivilege) ||
                              (t.privilege && authPrivileges.includes(t.privilege)) ||
                              (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))
                            ).icon
                          }
                        />
                      }
                      onClick={
                        e.subLinks.find(t =>
                          (!t.privilege && !t.atLeastOnePrivilege) ||
                          (t.privilege && authPrivileges.includes(t.privilege)) ||
                          (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))
                        ).onClick
                          ? e.subLinks.find(t =>
                              (!t.privilege && !t.atLeastOnePrivilege) ||
                              (t.privilege && authPrivileges.includes(t.privilege)) ||
                              (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))
                            ).onClick
                          : ev =>
                              goToPath(
                                ev,
                                e.subLinks.find(t =>
                                  (!t.privilege && !t.atLeastOnePrivilege) ||
                                  (t.privilege && authPrivileges.includes(t.privilege)) ||
                                  (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))
                                ).path
                              )
                      }
                      active={isAtPath(
                        e.subLinks.find(t =>
                          (!t.privilege && !t.atLeastOnePrivilege) ||
                          (t.privilege && authPrivileges.includes(t.privilege)) ||
                          (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))
                        ).path
                      )}
                      title={
                        e.subLinks.find(t =>
                          (!t.privilege && !t.atLeastOnePrivilege) ||
                          (t.privilege && authPrivileges.includes(t.privilege)) ||
                          (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))
                        ).title
                      }
                      key={key}
                      suffix={!!(e.subLinks.find(t =>
                          (!t.privilege && !t.atLeastOnePrivilege) ||
                          (t.privilege && authPrivileges.includes(t.privilege)) ||
                          (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))
                        ).pendingCode && pending?.[e.subLinks.find(t =>
                          (!t.privilege && !t.atLeastOnePrivilege) ||
                          (t.privilege && authPrivileges.includes(t.privilege)) ||
                          (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))
                        ).pendingCode]) && <span className="sideBarBadge">{pending?.[e.subLinks.find(t =>
                          (!t.privilege && !t.atLeastOnePrivilege) ||
                          (t.privilege && authPrivileges.includes(t.privilege)) ||
                          (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))
                        ).pendingCode]}</span>}
                    >
                      {
                        e.subLinks.find(t =>
                          (!t.privilege && !t.atLeastOnePrivilege) ||
                          (t.privilege && authPrivileges.includes(t.privilege)) ||
                          (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => authPrivileges.includes(n)))
                        ).title
                      }
                    </MenuItem>
                  : null
            )
            : <MenuItem
                icon={<FontAwesomeIcon icon={e.icon} />}
                onClick={e.onClick ? e.onClick : ev => goToPath(ev, e.path)}
                active={isAtPath(e.path)}
                title={e.title}
                key={key}
                prefix={!!(e.pendingCode && pending?.[e.pendingCode]) && <span className="sideBarBadge">{pending?.[e.pendingCode]}</span>}
                suffix={!!(e.pendingCode && pending?.[e.pendingCode]) && <span className="sideBarBadge">{pending?.[e.pendingCode]}</span>}
              >
                {!!(e.pendingCode && pending?.[e.pendingCode] && false) && <span className="sideBarBadge">{pending?.[e.pendingCode]}</span>} {e.title}
              </MenuItem>
          : null
      }
    )
  }

  const getLinks = (section, authPrivileges) => {
    const isAllowed = e =>
      (!e.privilege && !e.atLeastOnePrivilege) ||
      (e.privilege && authPrivileges.includes(e.privilege)) ||
      (e.atLeastOnePrivilege && e.atLeastOnePrivilege.some(p => authPrivileges.includes(p)))

    const badge = code => !!(code && pending?.[code]) && <span className="sideBarBadge" title={pending[code]}>{pending[code]}</span>
    const groupBadges = codes => !!(codes?.length && codes.find(e => !!pending?.[e])) && <span className="sideBarBadge" title={codes.reduce((e, t) => e + Number(pending[t] || 0), 0)}>{codes.reduce((e, t) => e + Number(pending[t] || 0), 0)}</span>

    return section?.links?.map((e, key) => {
      const validSubLinks = e.subLinks?.filter(isAllowed) || []

      if((!e.privilege && !e.atLeastOnePrivilege && validSubLinks.length > 0) ||
        (e.privilege && authPrivileges.includes(e.privilege)) ||
        (e.atLeastOnePrivilege && e.atLeastOnePrivilege.some(p => authPrivileges.includes(p)))){
        if(e.subLinks){
          if(validSubLinks.length > 1){
            return <SubMenu
              title={e.title}
              icon={<FontAwesomeIcon icon={e.icon} />}
              className={validSubLinks.some(t => isAtPath(t.path)) ? "myProSideBarActiveSubMenu" : ""}
              key={key}
              suffix={groupBadges(validSubLinks.map(e => e.pendingCode))}
            >
              {validSubLinks.map((t, tKey) => (
                <MenuItem
                  key={tKey}
                  onClick={t.onClick || (ev => goToPath(ev, t.path))}
                  active={isAtPath(t.path)}
                  icon={<FontAwesomeIcon icon={t.icon} />}
                  title={t.title}
                  suffix={badge(t.pendingCode)}
                >
                  {t.title}
                </MenuItem>
              ))}
            </SubMenu>
          }
          else if(validSubLinks.length === 1){
            const t = validSubLinks[0]
            return <MenuItem
              key={key}
              icon={<FontAwesomeIcon icon={t.iconWhenAlone || t.icon} />}
              onClick={t.onClick || (ev => goToPath(ev, t.path))}
              active={isAtPath(t.path)}
              title={t.title}
              suffix={badge(t.pendingCode)}
            >
              {t.title}
            </MenuItem>
          }
        }
        else{
          return <MenuItem
            key={key}
            icon={<FontAwesomeIcon icon={e.icon} />}
            onClick={e.onClick || (ev => goToPath(ev, e.path))}
            active={isAtPath(e.path)}
            title={e.title}
            suffix={badge(e.pendingCode)}
          >
            {e.title}
          </MenuItem>
        }
      }

      return null
    })
  }

  return (
    <div className="myProSideBarContainer">
      <ClickOutside onClickOutside={() => setCollapsed(true)} >
        <ProSidebar collapsedWidth="66px" width="250px" collapsed={collapsed}>
          <SidebarHeader>
            <button role="button" className="mySideBarToggler" aria-expanded={!collapsed} onClick={() => setCollapsed(!collapsed)}>
              <span className="mySideBarTogglerBars"></span>
              <span className="mySideBarTogglerBars"></span>
              <span className="mySideBarTogglerBars"></span>
            </button>
          </SidebarHeader>
          {/* <SidebarHeader><FaBars className="pro-sidebar-custom-toggle-icon" onClick={() => setCollapsed(!collapsed)} /></SidebarHeader> */}
          <SidebarContent>
            {auth?.user && auth?.user?.id !== 76 ? <Menu iconShape="circle">
              {allLinks.map((linkGroup, key) => ((linkGroup.specialities ? linkGroup.specialities.includes(auth.user.speciality) : auth.user.speciality === linkGroup.speciality) ? [<div className="myProSideBarTitles" key={key + "Titles"}><div className="myProSideBarTitleText">{linkGroup.title}</div><div className={`myProSideBarSeparator${key === 0 ? " firstSeparator" : ""}`}></div></div>, ...getLinks(linkGroup, auth.user.privileges)] : [<div className="myProSideBarSeparator" style={key === 0 ? {display: "none"} : {}}></div>, ...((!linkGroup?.links || linkGroup.links.filter(e => (!e.privilege && !e.atLeastOnePrivilege && (!e.subLinks || e.subLinks.filter(t => (!t.privilege && !t.atLeastOnePrivilege) || (t.privilege && auth.user.privileges.includes(t.privilege)) || (t.atLeastOnePrivilege && t.atLeastOnePrivilege.some(n => auth.user.privileges.includes(n)))).length > 0)) || (e.privilege && auth.user.privileges.includes(e.privilege)) || (e.atLeastOnePrivilege && e.atLeastOnePrivilege.some(n => auth.user.privileges.includes(n)))).length > 0) ? [<SubMenu title={linkGroup.title} icon={<FontAwesomeIcon icon={linkGroup.icon} />} className={!!linkGroup.links.find(e => (e.path && isAtPath(e.path)) || e.subLinks?.find(t => isAtPath(t.path))) ? "myProSideBarActiveSubMenu" : ""}>
                {getLinks(linkGroup, auth.user.privileges)}
              </SubMenu>] : [])]))}
            </Menu> : null}
          </SidebarContent>
        </ProSidebar>
      </ClickOutside>
      <ClientAdd modal={clientAddModal} setModal={setClientAddModal} handleToggle={handleClientAddToggle} />
      <ProspectAdd modal={prospectAddModal} setModal={setProspectAddModal} />
      <VisitorAdd modal={visitorAddModal} setModal={setVisitorAddModal} />
    </div>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth
});

export default connect(mapStateToProps, null)(ProSideBar);